import model from "@/ts/model";
import type { CategoryID } from "@/ts/types/category-id-types";

export function isNavViewItemActive(view: CategoryID | null){
    return model.view == view && !model.gameFilter.displayed;
}